module.exports = __webpack_public_path__ + "img/bank-refresh.bf7bd0f0.svg";